import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetPlanReviewRulesQueryVariables = Types.Exact<{
  jurisdictionId: Types.Scalars['uuid']['input'];
}>;


export type GetPlanReviewRulesQuery = { __typename?: 'query_root', plan_review_requirements: Array<{ __typename?: 'plan_review_requirements', id: any, jurisdiction_id: any, requirement_type: string, category_id: any, code?: string | null, title: string, description: string, applicable_codes?: any | null, source?: string | null, section?: string | null, source_url?: string | null, default_severity?: string | null, required: boolean, sort_order: number, active: boolean, origin: string, extraction_id?: any | null, category_record: { __typename?: 'plan_review_categories', id: any, name: string, sort_order: number }, plan_review_requirement_code_sections: Array<{ __typename?: 'plan_review_requirement_code_sections', code_section_id: any, citation_text?: string | null, origin: string, sort_order: number, code_section: { __typename?: 'code_sections', id: any, section_number: string, title?: string | null, page_number?: number | null, code_book: { __typename?: 'code_books', id: any, abbreviation: string, edition_year?: number | null, book_type: string } } }>, plan_review_requirement_submission_types: Array<{ __typename?: 'plan_review_requirement_submission_types', submission_type_id: any, submission_type: { __typename?: 'plan_review_submission_types', id: any, name: string, short_name?: string | null } }> }> };


export const GetPlanReviewRulesDocument = gql`
    query getPlanReviewRules($jurisdictionId: uuid!) {
  plan_review_requirements(
    where: {jurisdiction_id: {_eq: $jurisdictionId}}
    order_by: [{category_record: {sort_order: asc}}, {sort_order: asc}]
  ) {
    id
    jurisdiction_id
    requirement_type
    category_id
    category_record {
      id
      name
      sort_order
    }
    code
    title
    description
    applicable_codes
    source
    section
    source_url
    default_severity
    required
    sort_order
    active
    origin
    extraction_id
    plan_review_requirement_code_sections(order_by: {sort_order: asc}) {
      code_section_id
      citation_text
      origin
      sort_order
      code_section {
        id
        section_number
        title
        page_number
        code_book {
          id
          abbreviation
          edition_year
          book_type
        }
      }
    }
    plan_review_requirement_submission_types {
      submission_type_id
      submission_type {
        id
        name
        short_name
      }
    }
  }
}
    `;

/**
 * __useGetPlanReviewRulesQuery__
 *
 * To run a query within a React component, call `useGetPlanReviewRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlanReviewRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlanReviewRulesQuery({
 *   variables: {
 *      jurisdictionId: // value for 'jurisdictionId'
 *   },
 * });
 */
export function useGetPlanReviewRulesQuery(baseOptions: Apollo.QueryHookOptions<GetPlanReviewRulesQuery, GetPlanReviewRulesQueryVariables> & ({ variables: GetPlanReviewRulesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlanReviewRulesQuery, GetPlanReviewRulesQueryVariables>(GetPlanReviewRulesDocument, options);
      }
export function useGetPlanReviewRulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlanReviewRulesQuery, GetPlanReviewRulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlanReviewRulesQuery, GetPlanReviewRulesQueryVariables>(GetPlanReviewRulesDocument, options);
        }
export function useGetPlanReviewRulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlanReviewRulesQuery, GetPlanReviewRulesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPlanReviewRulesQuery, GetPlanReviewRulesQueryVariables>(GetPlanReviewRulesDocument, options);
        }
export type GetPlanReviewRulesQueryHookResult = ReturnType<typeof useGetPlanReviewRulesQuery>;
export type GetPlanReviewRulesLazyQueryHookResult = ReturnType<typeof useGetPlanReviewRulesLazyQuery>;
export type GetPlanReviewRulesSuspenseQueryHookResult = ReturnType<typeof useGetPlanReviewRulesSuspenseQuery>;
export type GetPlanReviewRulesQueryResult = Apollo.QueryResult<GetPlanReviewRulesQuery, GetPlanReviewRulesQueryVariables>;